import React, { useState, useEffect } from 'react'
import Alert from '../../../../feature/Alert';
import { useTranslation } from 'react-i18next';
import { COMPANY_DETAILS, SAVE_COMPANY_DETAILS } from '../../../../data/url';
import httpClient from '../../../../http/HttpRequest';
import FormLayout from '../../layout/FormLayout';

export default function CompanyBank() {  
     const { t } = useTranslation();
     const [directSubmit, setDirectSubmit] = useState(1);
     const [companyData, setcompanyData] = useState({});
     const [formData, setFormData] = useState({
          formTitle: 'Company Profile',
          formFields: [
               { label: 'bank_name', id: 'bank_name', type: 'text', name: 'bank_name', value: '', required: true, className: "col-md-6" },
               { label: 'account_number', id: 'account_number', type: 'text', name: 'account_number', value: '', className: "col-md-6" },
               { label: 'ifsc', id: 'ifsc', type: 'text', name: 'ifsc', value: '', className: "col-md-6" },
               { label: 'branch', id: 'branch', type: 'text', name: 'branch', value: '', className: "col-md-6" },
               { label: 'upi_id', id: 'upi_id', type: 'text', name: 'upi_id', value: '', options: [], className: "col-md-6" },

          ],
          formErrors: { bank_name: '', account_number: '', ifsc: '', branch: '', upi_id: '' },
     });

     useEffect(() => {
          getCompanyDetails();
     }, []);

     const getCompanyDetails = async () => {
          const res = await httpClient.post(COMPANY_DETAILS, {});
          if (res.requestStatus === 'OK') {
               const result = res.result;
               if (result.status === 1) {
                    setcompanyData(result.data);
                    setFormData(prevFormData => {
                         const updatedFormFields = prevFormData.formFields.map(field => {
                              if (field.name in result.data) {
                                   field.value = result.data[field.name];
                              }
                              return field;
                         });
                         return {
                              ...prevFormData,
                              formFields: updatedFormFields,
                         };
                    });
               } else {
                    Alert.error(res.message);
               }
          }
     };

     function handleFieldChange(fieldName, value) {
          setDirectSubmit(0);
          setFormData((prevFormData) => {
               const updatedFormFields = prevFormData.formFields.map((field) =>
                    field.name === fieldName ? { ...field, value: value } : field
               );
               return {
                    ...prevFormData,
                    formFields: updatedFormFields,
               };
          });
     }

     function handleFieldBlur(fieldName, value) {
          setDirectSubmit(0);
          validateField(fieldName, value);
     }

     function validateField(fieldName, value) {
          setFormData((prevFormData) => {
               const updatedErrors = { ...prevFormData.formErrors };
               if (fieldName === 'bank_name') {
                    updatedErrors.bank_name = value.trim() === '' ? 'field_required' : '';
               }
               if (fieldName === 'account_number') {
                    updatedErrors.account_number = value.trim() === '' ? 'field_required' : '';
               }
               if (fieldName === 'ifsc') {
                    updatedErrors.ifsc = value.trim() === '' ? 'field_required' : '';
               }
               return {
                    ...prevFormData,
                    formErrors: updatedErrors,
               };
          });

          return formData.formErrors;

     }

     function handleSubmit(e) {
          e.preventDefault();
          let post = {};
          let hasErrors = false;
          const updatedFormFields = formData.formFields.map((field) => {
               const allError = validateField(field.name, field.value);
               const error = allError[field.name];
               if (error !== '' && typeof error !== 'undefined') {
                    hasErrors = true;
               } else {
                    post[field.name] = field.value;
               }
               return field;
          });
          setFormData((prevFormData) => ({
               ...prevFormData,
               formFields: updatedFormFields,
          }));
          if (!hasErrors && directSubmit === 0) {
               post['company_id'] = companyData.company_id;
               subtmitData(post);
          } else {
               Alert.warning(t('you_did_not_change_anything'));
          }
     }

     const subtmitData = async (post) => {
          post['state'] = post['state'] === '' ? null : post['state'];
          const res = await httpClient.post(SAVE_COMPANY_DETAILS, post);
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    Alert.success(result.message);
               } else {
                    Alert.failure(result.message);
               }
          }
     }

     function handleReset() {
          const updatedFormFields = formData.formFields.map((field) => ({
               ...field,
               value: '',
          }));

          setFormData((prevFormData) => ({
               ...prevFormData,
               formFields: updatedFormFields,
               formErrors: {},
          }));
     }

     return (
          <div className='col-md-8 m-auto'>
               <FormLayout
                    formTitle={formData.formTitle}
                    formFields={formData.formFields}
                    formErrors={formData.formErrors}
                    onFieldChange={handleFieldChange}
                    onFieldBlur={handleFieldBlur}
                    onSubmit={handleSubmit}
                    handleReset={handleReset}
               />
          </div>

     )
}
